import { useTranslations } from '@npco/common-utils-translations'
import { Box } from '@npco/zeller-design-system'

import { ReactComponent as ArrowBadge } from 'assets/svg/setup-flow/arrow-top.svg'

import { Message } from '../../../../SetupFlowModal.styled'
import { setupFlowAccountDetailsTranslations } from './AccountDetails.i18n'

export const AccountDetailsCopyInfo = () => {
  const t = useTranslations(setupFlowAccountDetailsTranslations)

  return (
    <>
      <Box
        position="absolute"
        right={{ _: '16px', LG: '24px' }}
        top={{ _: '60px', LG: '-15px' }}
      >
        <ArrowBadge />
      </Box>
      <Box
        maxWidth="192px"
        position="absolute"
        top={{ _: '-5px', LG: '-90px' }}
        right={{ _: 'unset', LG: '-40px' }}
        textAlign="center"
      >
        <Message>{t('copyMessage')}</Message>
      </Box>
    </>
  )
}
